<template>
  <el-table-column
    prop="net_price"
    label="Nettó ár"
    width="150"
    show-overflow-tooltip
  >
    <template slot-scope="scope">
      {{ scope.row.net_price | currency }}
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'net_price',
};
</script>
